import { CMSModule } from '@/components';
import classNames from 'classnames';
import { ModuleBaseModel, ModuleBaseNameProps, ModuleBasePropsModel } from '@/types';

export type FullPageSlideMultiChildElementModel = {
  modules: ModuleBaseModel<ModuleBasePropsModel>[];
  backgroundColor?: string;
} & ModuleBaseNameProps;

const FullPageSlideMultiChildElement = ({ modules, backgroundColor }: FullPageSlideMultiChildElementModel) => {
  const lastModuleBackgroundColor =
    (modules?.length > 1 ? modules?.[modules?.length - 1] : null)?.props.backgroundColour || backgroundColor;

  return (
    <div
      className={classNames(
        'multi-child-element flex min-h-full w-full flex-col',
        modules?.length === 1
          ? '[&_.InfoBlockModule]:flex [&_.InfoBlockModule]:items-center [&_.module]:min-h-full'
          : 'justify-between [&_.InfoBlockModule]:!py-18',
      )}
    >
      {lastModuleBackgroundColor && (
        <div style={{ backgroundColor: lastModuleBackgroundColor }} className="absolute bottom-0 h-1/3 w-full" />
      )}
      {modules?.map((module) => (
        <CMSModule
          key={module.id}
          module={{
            ...module,
            props: { ...module.props, backgroundColour: module.props?.backgroundColour || backgroundColor },
          }}
        />
      ))}
    </div>
  );
};

export default FullPageSlideMultiChildElement;
